import script from "./People.vue?vue&type=script&lang=ts&setup=true"
export * from "./People.vue?vue&type=script&lang=ts&setup=true"

import "./People.vue?vue&type=style&index=0&id=21528e54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21528e54"]])

export default __exports__